import avatar1 from '../../../../../../assets/images/user/avatar-1.jpg';
import avatar2 from '../../../../../../assets/images/user/avatar-2.jpg';
import avatar3 from '../../../../../../assets/images/user/avatar-3.jpg';
import avatar4 from '../../../../../../assets/images/user/avatar-4.jpg';

const friends = [
  {
    id: 1,
    photo: avatar1,
    name: 'Josephin Doe',
    new: 3,
    status: 1,
    time: 'typing'
  },
  {
    id: 2,
    photo: avatar2,
    name: 'Lary Doe',
    new: 1,
    status: 1,
    time: 'online'
  },
  {
    id: 3,
    photo: avatar3,
    name: 'Alice',
    status: 1,
    time: 'online'
  },
  {
    id: 4,
    photo: avatar1,
    name: 'Alia',
    status: 0,
    new: 1,
    time: '10 min ago'
  },
  {
    id: 5,
    photo: avatar4,
    name: 'Suzen',
    status: 0,
    time: '15 min ago'
  },
  {
    id: 6,
    photo: avatar1,
    name: 'Josephin Doe',
    new: 3,
    status: 1,
    time: 'typing'
  },
  {
    id: 7,
    photo: avatar2,
    name: 'Lary Doe',
    new: 1,
    status: 1,
    time: 'online'
  },
  {
    id: 8,
    photo: avatar3,
    name: 'Alice',
    status: 1,
    time: 'online'
  },
  {
    id: 9,
    photo: avatar1,
    name: 'Alia',
    status: 0,
    new: 1,
    time: '10 min ago'
  },
  {
    id: 10,
    photo: avatar4,
    name: 'Suzen',
    status: 0,
    time: '15 min ago'
  },
  {
    id: 11,
    photo: avatar1,
    name: 'Josephin Doe',
    new: 3,
    status: 1,
    time: 'typing'
  },
  {
    id: 12,
    photo: avatar2,
    name: 'Lary Doe',
    new: 1,
    status: 1,
    time: 'online'
  },
  {
    id: 13,
    photo: avatar3,
    name: 'Alice',
    status: 1,
    time: 'online'
  },
  {
    id: 14,
    photo: avatar1,
    name: 'Alia',
    status: 0,
    new: 1,
    time: '10 min ago'
  },
  {
    id: 15,
    photo: avatar4,
    name: 'Suzen',
    status: 0,
    time: '15 min ago'
  },
  {
    id: 16,
    photo: avatar1,
    name: 'Josephin Doe',
    new: 3,
    status: 1,
    time: 'typing'
  },
  {
    id: 17,
    photo: avatar2,
    name: 'Lary Doe',
    new: 1,
    status: 1,
    time: 'online'
  },
  {
    id: 18,
    photo: avatar3,
    name: 'Alice',
    status: 1,
    time: 'online'
  },
  {
    id: 19,
    photo: avatar1,
    name: 'Alia',
    status: 0,
    new: 1,
    time: '10 min ago'
  },
  {
    id: 20,
    photo: avatar4,
    name: 'Suzen',
    status: 0,
    time: '15 min ago'
  },
  {
    id: 21,
    photo: avatar1,
    name: 'Josephin Doe',
    new: 3,
    status: 1,
    time: 'typing'
  },
  {
    id: 22,
    photo: avatar2,
    name: 'Lary Doe',
    new: 1,
    status: 1,
    time: 'online'
  },
  {
    id: 23,
    photo: avatar3,
    name: 'Alice',
    status: 1,
    time: 'online'
  },
  {
    id: 24,
    photo: avatar1,
    name: 'Alia',
    status: 0,
    new: 1,
    time: '10 min ago'
  },
  {
    id: 25,
    photo: avatar4,
    name: 'Suzen',
    status: 0,
    time: '15 min ago'
  }
];

export default friends;
